import { isAsyncIterable } from './utils/iterator.js';
export function reduce(fn, initial) {
    return function reduceFn(data) {
        if (data == null)
            return;
        let acc = initial;
        if (isAsyncIterable(data) || data instanceof Promise) {
            return (async () => {
                let stream = data instanceof Promise ? await data : data;
                let i = 0;
                for await (let datum of stream)
                    acc = fn(acc, datum, i++);
                return acc;
            })();
        }
        let i = 0;
        for (let datum of data)
            acc = fn(acc, datum, i++);
        return acc;
    };
}
